import AddIcon from '@mui/icons-material/Add';
import { Tooltip, IconButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import BasicTitle from './BasicTitle.js';
import { useCheckPermissions } from '../../auth/index.js';

const PatientsBarContent = () => {
  const navigate = useNavigate();
  const { canCreatePatient } = useCheckPermissions();

  return (
    <>
      <BasicTitle text={'Patients'} />
      {canCreatePatient ? (
        <Tooltip arrow color="primary" placement="bottom" title={'Add a new patient'}>
          <IconButton
            color="inherit"
            aria-label="add new patient"
            onClick={() => navigate('/patients/new')}
            edge="start"
            sx={{
              marginLeft: 'auto',
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      ) : null}
    </>
  );
};

export default PatientsBarContent;
